import { useNavigate } from "react-router-dom";
import { ClipboardPlus, ScanBarcode, SearchIcon, Upload } from "lucide-react";
import { AttachDialog } from "../../components/Dialog/attach-image-dialog.component";
import { useState } from "react";
import { CreateJobDialog } from "../../components/Dialog/create-job-dialog.component";
import { useCentralStore } from "../../store/Central";
import { InputBase } from "@mui/material";

export const ActionsPage = () => {
	const {organization} = useCentralStore();
  const [image, setImage] = useState<File | null>(null);
  const navigate = useNavigate();
	const [open, setOpen] = useState(false);
  const [jobId, setJobId] = useState<string | null>(null);
  const [jobDocumentId, setJobDocumentId] = useState<string | null>(null);
	const [search, setSearch] = useState("");

  const handleClose = (success: boolean, jobId?: string, jobDocumentId?: string) => {
    if (success && jobId && jobDocumentId) {
      setJobId(jobId);
      setJobDocumentId(jobDocumentId);
      setOpen(false);
    } else {
      navigate("/actions");
      setOpen(false);
    }
  };

  if (jobId && jobDocumentId) {
    navigate(`/job/${jobId}`);
  }

	const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
		const file = event.target.files?.[0];
		if (!file) return;
		setImage(file);
	};


	return (
		<div className="flex flex-col gap-2 h-full justify-center">
			<div className="text-2xl font-bold mb-8">
				{organization?.name}
			</div>
		<div className="flex flex-col gap-6 h-3/4 items-between justify-between">
			<div
				className="p-2 bg-blue-100 h-1/3 w-full rounded cursor-pointer transition-colors active:bg-blue-200"
        onClick={() => {
          setOpen(true);
        }}
			>
				<div className="flex flex-row gap-2 h-full w-full items-center justify-center">
          <div className="flex flex-row gap-2 items-center justify-center">
            <ClipboardPlus size={72} />
          </div>
					<div className="flex-1 text-lg font-bold text-center">
						Neuen Auftrag erstellen
					</div>
				</div>
			</div>
			<div
				className="p-2 bg-blue-100 h-1/3 w-full rounded cursor-pointer transition-colors active:bg-blue-200"
        onClick={() => {
          navigate("/scan");
        }}
			>
				<div className="flex flex-row gap-2 h-full w-full items-center justify-center">
          <div className="flex flex-row gap-2 items-center justify-center">
            <ScanBarcode size={72} />
          </div>
					<div className="flex-1 text-lg font-bold text-center">
						Auftragsetikett oder <br/> Material scannen
					</div>
				</div>
			</div>
			<div
				className="p-2 bg-blue-100 h-1/3 w-full rounded cursor-pointer transition-colors active:bg-blue-200"
			>
          <label htmlFor="image" className="flex flex-row gap-2 h-full w-full items-center justify-center">
					<div className="flex flex-row gap-2 items-center justify-center">
            <Upload size={72} />
          </div>	
          <div className="flex flex-row gap-2 h-full w-full items-center justify-center">
					<div className="flex-1 text-lg font-bold text-center">
						Foto hochladen
					</div>
          <input
							id="image"
							type="file"
							accept="image/*"
							onChange={handleFileUpload}
							style={{ display: "none" }}
						/>
          </div>
        </label>
				</div>
			{image && (
				<AttachDialog image={image} onClose={() => setImage(null)} />
			)}
			<CreateJobDialog
      open={open}
      onClose={handleClose}
    	/>
		</div>
		</div>
	);
};
						